module.exports = __webpack_public_path__ + "img/cavalier-challenge-2_a3c25e493945de74df7f903d8a499bb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/cavalier-challenge-2.jpg
// module id = 265
// module chunks = 0